var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMemo } from 'react';
import { ColumnMetaDataContext } from '@common/api';
export function useMissingTags(columnMetas, importJobRows, tagByIdMap) {
    return useMemo(function () {
        var e_1, _a;
        // first use sets (to avoid duplicate dimensions)
        var missingTagNamesSets = {};
        // go through every column
        for (var columnIndex = 0; columnIndex < columnMetas.length; columnIndex++) {
            var columnMeta = columnMetas[columnIndex];
            if (columnMeta.dataContext !== ColumnMetaDataContext.IDENTIFIER ||
                columnMeta.tableTagId === undefined ||
                !!columnMeta.manualMapping) {
                // only analyze IDENTIFIER (Table) columns with set table tag and NO manual mapping
                continue;
            }
            // cast "detectedTagMap" because openapi types can't have Partial<...>
            var detectedTagMap = columnMeta.detectedTagMap;
            // read rows for this column
            for (var rowIndex = 0; rowIndex < importJobRows.length; rowIndex++) {
                var rowData = importJobRows[rowIndex].data;
                var rawValue = rowData[columnIndex];
                if (rawValue === '' || rawValue === null) {
                    // don't add empty tags
                    continue;
                }
                if (typeof rawValue !== 'string' && typeof rawValue !== 'number') {
                    // unknown data type
                    continue;
                }
                var dimensionName = String(rawValue).trim();
                if (detectedTagMap === undefined || detectedTagMap[dimensionName] === undefined) {
                    // dimension name is not in detectedTagMap
                    if (missingTagNamesSets[columnIndex] === undefined) {
                        // create set if it doesn't exist for this column
                        missingTagNamesSets[columnIndex] = new Set();
                    }
                    missingTagNamesSets[columnIndex].add(dimensionName);
                }
            }
        }
        // analyze columns with missing tags
        var columnIndicesWithMissingTags = Object.keys(missingTagNamesSets).map(function (idx) { return Number.parseInt(idx); });
        // create return result
        var missingTags = {};
        try {
            for (var columnIndicesWithMissingTags_1 = __values(columnIndicesWithMissingTags), columnIndicesWithMissingTags_1_1 = columnIndicesWithMissingTags_1.next(); !columnIndicesWithMissingTags_1_1.done; columnIndicesWithMissingTags_1_1 = columnIndicesWithMissingTags_1.next()) {
                var columnIndex = columnIndicesWithMissingTags_1_1.value;
                var missingTagNameSet = missingTagNamesSets[columnIndex];
                if (missingTagNameSet === undefined) {
                    // shouldn't happen, but here because of Partial<...>
                    continue;
                }
                var columnMeta = columnMetas[columnIndex];
                if (columnMeta.dataContext === ColumnMetaDataContext.IDENTIFIER &&
                    columnMeta.tableTagId !== undefined &&
                    !columnMeta.manualMapping) {
                    // only add missing tags for IDENTIFIER (Table) columns with set table tag and NO manual mapping
                    var foundTableTag = tagByIdMap[columnMeta.tableTagId];
                    if (foundTableTag === undefined) {
                        // selected table tag does not exist
                        continue;
                    }
                    // create column
                    var missingTagsColumn = {
                        tableTagId: foundTableTag.id,
                        tagNames: Array.from(missingTagNameSet),
                    };
                    // add column to result
                    missingTags[columnIndex] = missingTagsColumn;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (columnIndicesWithMissingTags_1_1 && !columnIndicesWithMissingTags_1_1.done && (_a = columnIndicesWithMissingTags_1.return)) _a.call(columnIndicesWithMissingTags_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return missingTags;
    }, [columnMetas, importJobRows, tagByIdMap]);
}
